import { formatPhoneNumberIntl } from "react-phone-number-input";
import { fromApiPhoneNumber } from "utils/phoneNumber.logic";

const EMPTY_PHONE_LABEL = "-";

/**
 * Formats a phone number for staff views, for example `+46 70 123 45 67`.
 *
 * Numbers arrive from the API as bare digits, so the plus goes back on before
 * the library reads them. Anything the library cannot place is shown as it was
 * stored rather than hidden.
 */
export const formatStaffPhoneNumber = (phoneNumber: string | null): string => {
  const internationalPhoneNumber = fromApiPhoneNumber(phoneNumber);
  if (internationalPhoneNumber.length === 0) return EMPTY_PHONE_LABEL;

  const formattedPhoneNumber = formatPhoneNumberIntl(internationalPhoneNumber);
  return formattedPhoneNumber.length === 0
    ? internationalPhoneNumber
    : formattedPhoneNumber;
};
